module.exports = __webpack_public_path__ + "static/img/3.1fd349b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/sp/3.png
// module id = Xnke
// module chunks = 0